/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ResourceCategoryFragment = { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null };

export type ResourceCategoryQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type ResourceCategoryQuery = { __typename: 'Query', resourceCategory?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null };

export type ResourceCategoriesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  parent_Isnull?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ResourceCategoriesQuery = { __typename: 'Query', resourceCategories?: { __typename: 'ResourceCategoryTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ResourceCategoryTypeEdge', node?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ResourceCategoryFragmentDoc = new TypedDocumentString(`
    fragment ResourceCategory on ResourceCategoryType {
  id
  name
  parent {
    id
    name
  }
}
    `, {"fragmentName":"ResourceCategory"});
export const ResourceCategoryDocument = new TypedDocumentString(`
    query ResourceCategory($id: UUID!) {
  resourceCategory(id: $id) {
    ...ResourceCategory
  }
}
    fragment ResourceCategory on ResourceCategoryType {
  id
  name
  parent {
    id
    name
  }
}`);

export const useResourceCategoryQuery = <
      TData = ResourceCategoryQuery,
      TError = unknown
    >(
      variables: ResourceCategoryQueryVariables,
      options?: Omit<UseQueryOptions<ResourceCategoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ResourceCategoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ResourceCategoryQuery, TError, TData>(
      {
    queryKey: ['ResourceCategory', variables],
    queryFn: fetcher<ResourceCategoryQuery, ResourceCategoryQueryVariables>(ResourceCategoryDocument, variables),
    ...options
  }
    )};

useResourceCategoryQuery.getKey = (variables: ResourceCategoryQueryVariables) => ['ResourceCategory', variables];

export const useInfiniteResourceCategoryQuery = <
      TData = InfiniteData<ResourceCategoryQuery>,
      TError = unknown
    >(
      variables: ResourceCategoryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ResourceCategoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ResourceCategoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ResourceCategoryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ResourceCategory.infinite', variables],
      queryFn: (metaData) => fetcher<ResourceCategoryQuery, ResourceCategoryQueryVariables>(ResourceCategoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteResourceCategoryQuery.getKey = (variables: ResourceCategoryQueryVariables) => ['ResourceCategory.infinite', variables];


useResourceCategoryQuery.fetcher = (variables: ResourceCategoryQueryVariables) => fetcher<ResourceCategoryQuery, ResourceCategoryQueryVariables>(ResourceCategoryDocument, variables);

export const ResourceCategoriesDocument = new TypedDocumentString(`
    query ResourceCategories($after: String, $first: Int, $before: String, $last: Int, $offset: Int, $name_Icontains: String, $parent_Isnull: Boolean) {
  resourceCategories(
    after: $after
    first: $first
    before: $before
    last: $last
    offset: $offset
    name_Icontains: $name_Icontains
    parent_Isnull: $parent_Isnull
  ) {
    edges {
      node {
        ...ResourceCategory
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ResourceCategory on ResourceCategoryType {
  id
  name
  parent {
    id
    name
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);

export const useResourceCategoriesQuery = <
      TData = ResourceCategoriesQuery,
      TError = unknown
    >(
      variables?: ResourceCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<ResourceCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ResourceCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ResourceCategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ResourceCategories'] : ['ResourceCategories', variables],
    queryFn: fetcher<ResourceCategoriesQuery, ResourceCategoriesQueryVariables>(ResourceCategoriesDocument, variables),
    ...options
  }
    )};

useResourceCategoriesQuery.getKey = (variables?: ResourceCategoriesQueryVariables) => variables === undefined ? ['ResourceCategories'] : ['ResourceCategories', variables];

export const useInfiniteResourceCategoriesQuery = <
      TData = InfiniteData<ResourceCategoriesQuery>,
      TError = unknown
    >(
      variables: ResourceCategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ResourceCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ResourceCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ResourceCategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ResourceCategories.infinite'] : ['ResourceCategories.infinite', variables],
      queryFn: (metaData) => fetcher<ResourceCategoriesQuery, ResourceCategoriesQueryVariables>(ResourceCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteResourceCategoriesQuery.getKey = (variables?: ResourceCategoriesQueryVariables) => variables === undefined ? ['ResourceCategories.infinite'] : ['ResourceCategories.infinite', variables];


useResourceCategoriesQuery.fetcher = (variables?: ResourceCategoriesQueryVariables) => fetcher<ResourceCategoriesQuery, ResourceCategoriesQueryVariables>(ResourceCategoriesDocument, variables);
